"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributedRewardResponseToJSON = exports.DistributedRewardResponseFromJSONTyped = exports.DistributedRewardResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function DistributedRewardResponseFromJSON(json) {
    return DistributedRewardResponseFromJSONTyped(json, false);
}
exports.DistributedRewardResponseFromJSON = DistributedRewardResponseFromJSON;
function DistributedRewardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'rewardConfigId': json['rewardConfigId'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'userId': json['userId'],
        'subject': (0, _1.DistributedRewardSubjectFromJSON)(json['subject']),
        'webNotificationDismissed': json['webNotificationDismissed'],
        'devourPlayNotificationDismissed': json['devourPlayNotificationDismissed'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, _1.RewardTypeFromJSON)(json['type']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'notificationMetadata': !(0, runtime_1.exists)(json, 'notificationMetadata') ? undefined : (0, _1.NotificationMetadataFromJSON)(json['notificationMetadata']),
        'promoTokenId': !(0, runtime_1.exists)(json, 'promoTokenId') ? undefined : json['promoTokenId'],
        'couponCode': !(0, runtime_1.exists)(json, 'couponCode') ? undefined : json['couponCode'],
        'targetUrl': !(0, runtime_1.exists)(json, 'targetUrl') ? undefined : json['targetUrl'],
        'qrImageUrl': !(0, runtime_1.exists)(json, 'qrImageUrl') ? undefined : json['qrImageUrl'],
        'updatedAt': !(0, runtime_1.exists)(json, 'updatedAt') ? undefined : json['updatedAt'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : json['createdAt'],
    };
}
exports.DistributedRewardResponseFromJSONTyped = DistributedRewardResponseFromJSONTyped;
function DistributedRewardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'rewardConfigId': value.rewardConfigId,
        'amount': value.amount,
        'userId': value.userId,
        'subject': (0, _1.DistributedRewardSubjectToJSON)(value.subject),
        'webNotificationDismissed': value.webNotificationDismissed,
        'devourPlayNotificationDismissed': value.devourPlayNotificationDismissed,
        'type': (0, _1.RewardTypeToJSON)(value.type),
        'name': value.name,
        'description': value.description,
        'notificationMetadata': (0, _1.NotificationMetadataToJSON)(value.notificationMetadata),
        'promoTokenId': value.promoTokenId,
        'couponCode': value.couponCode,
        'targetUrl': value.targetUrl,
        'qrImageUrl': value.qrImageUrl,
        'updatedAt': value.updatedAt,
        'createdAt': value.createdAt,
    };
}
exports.DistributedRewardResponseToJSON = DistributedRewardResponseToJSON;
